<h2 mat-dialog-title class="text-lg font-semibold">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.ADD_INVOICE' | translate }}</h2>

<form [formGroup]="form">
  <div mat-dialog-content class="grid grid-cols-1 gap-6 w-[500px] max-w-full py-4">
    <mat-form-field appearance="fill" class="field">
      <mat-label>{{ 'BTB.DASHBOARD.TABLE.AMOUNT' | translate }}</mat-label>
      <input matInput type="text" formControlName="amount" inputmode="decimal" (input)="onAmountChange($event)" placeholder="0.00" />
      <mat-error *ngIf="form.get('amount')?.hasError('required')">{{ 'COMMON.REQUIRED_FIELD' | translate }}</mat-error>
      <mat-error *ngIf="form.get('amount')?.hasError('numeric')">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.INVALID_NUMBER' | translate }}</mat-error>
      <mat-error *ngIf="form.get('amount')?.hasError('min')">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.MIN_AMOUNT_ERROR' | translate }}</mat-error>
    </mat-form-field>

    <div class="field">
      <label class="block text-sm mb-2">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.INVOICE_PERIOD' | translate }}</label>
      <div class="grid grid-cols-2 gap-4">
        <mat-form-field appearance="fill">
          <mat-label>{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.START_DATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate" (dateChange)="onStartDateChange($event)" readonly>
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="form.get('startDate')?.hasError('required')">{{ 'COMMON.REQUIRED_FIELD' | translate }}</mat-error>
        </mat-form-field>
        
        <mat-form-field appearance="fill">
          <mat-label>{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.END_DATE' | translate }}</mat-label>
          <input matInput [matDatepicker]="endPicker" [min]="minEndDate" [matDatepickerFilter]="endDateFilter" formControlName="endDate" (dateChange)="onEndDateChange($event)" readonly>
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker [startAt]="minEndDate"></mat-datepicker>
          <mat-error *ngIf="form.get('endDate')?.hasError('required')">{{ 'COMMON.REQUIRED_FIELD' | translate }}</mat-error>
          <mat-error *ngIf="form.hasError('dateRangeInvalid')">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.INVALID_DATE_RANGE' | translate }}</mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="pt-2">
      <label class="block text-sm mb-1">PDF</label>
      <input type="file" accept="application/pdf" (change)="onFileSelected($event)" class="w-full" />
      <div class="text-xs text-red-600 mt-1" *ngIf="form.get('file')?.hasError('type')">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.MUST_BE_PDF' | translate }}</div>
      <div class="text-xs text-red-600 mt-1" *ngIf="form.get('file')?.hasError('required') && form.get('file')?.touched">{{ 'COMMON.REQUIRED_FIELD' | translate }}</div>
    </div>
  </div>
</form>

<div mat-dialog-actions class="actions pt-4">
  <button mat-stroked-button (click)="cancel()" [disabled]="isUploading">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="submit()" [disabled]="!isFormValid" class="inline-flex items-center">
    <div class="flex items-center">
      <mat-spinner *ngIf="isUploading" diameter="20" strokeWidth="2" class="mr-3"></mat-spinner>
      <span *ngIf="!isUploading">{{ 'BTB.DASHBOARD.PARTNER_DETAIL.INVOICES.ADD_BUTTON' | translate }}</span>
      <span *ngIf="isUploading">{{ 'BTB.DASHBOARD.UPLOADING' | translate }}</span>
    </div>
  </button>
</div>
